import React, {useEffect, useState, Fragment, useCallback, memo } from 'react';
import { Autocomplete } from '@material-ui/lab';
import {    
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField,
} from '@material-ui/core';
import { useAuth } from "../Auth";
import FacebookCircularProgress from '../Elementos/FacebookCircularProgress';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import { blue } from '@material-ui/core/colors';
import {
  Block as BlockIcon,
  CheckCircleOutline as CheckCircleOutlineIcon
} from '@material-ui/icons'

const columns = [
  { id: 'plan', label: 'Plan', minWidth: 170, align: 'left',numeric: false, disablePadding: false },
  { id: 'target', label: 'IP', minWidth: 170,align: 'left',numeric: false, disablePadding: false },
  { id: 'id1', label: 'idPrincipal', minWidth: 170,align: 'left',numeric: false, disablePadding: false },
  { id: 'id2', label: 'idSecundario', minWidth: 170,align: 'left',numeric: false, disablePadding: false },
  { id: 'name', label: 'Nombres', minWidth: 200,align: 'left', numeric: false, disablePadding: false },
  { id: 'status', label: 'Status', minWidth: 170, align: 'center', numeric: false, disablePadding: false}, 
  { id: 'action', label: 'Action', minWidth: 170, align: 'left', numeric: false, disablePadding: false}, 
];

const styles = makeStyles((theme)=>({
  paper:{
      padding:20
  },
  button:{
      color:'#fff'
  },
  backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
  },
  container: {
      minHeight: '73vh',
      maxHeight: '73vh',
  },
  visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
  },
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
};

function getComparator(order, orderBy) {
  return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
};

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort } = props;
  const createSorthandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead >
      <TableRow >
        {columns.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{background:blue[600], color:'#fff'}}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSorthandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

function capitalize(word) {
  return word[0].toUpperCase() + word.slice(1);
};

function MikrotikList (){
  const classes = styles();
  const { authTokens, setOpen } = useAuth(); 
  const [ dataZona, setDataZona ] = useState([]);
  const [ data, setData ] = useState([]);
  const [ dataBackup, setDataBackup ] = useState([]);
  const [ zonaSelected, setZonaSelected ] = useState('');
  const [ zonaSelectedObject, setZonaSelectedObject ] = useState({});
  const [ isSelectedZona, setSelectedZona ] = useState(false);
  const [ order, setOrder] = useState('asc');
  const [ orderBy, setOrderBy] = useState('name');
  const [ page, setPage] = useState(0);
  const [ rowsPerPage, setRowsPerPage] = useState(10);
  const [ isCharging, setCharging ] = useState(true);
  const [ userName, setUserName ] = useState('');
  const [ typeService, setTypeService ] = useState('');
  const [ arrPlanes, setArrPlanes ] = useState([]);


  useEffect(()=>{
    const handleData = async ()=>{
        setOpen(false);
        const dataZonas = await fetch('/api/zonas');
        const resultZonas = await dataZonas.json();
        if(authTokens.Type === 'ADMINISTRADOR'){
            setDataZona(resultZonas.filter(el=> el.Empresa === authTokens.Empresa));
        }else{
          const ZonasArr = authTokens.Zonas.map(valZon=> valZon.Zona);
          const arrFilZona = resultZonas.filter(el=> el.Empresa === authTokens.Empresa).filter(value=> ZonasArr.includes(value.Zona.toString()))
          setDataZona(arrFilZona); 
        }
    };

    handleData();
  },[]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClearZona = ()=>{
    setTypeService('');
    setZonaSelected('');
    setZonaSelectedObject({});
    setSelectedZona(false);
    setArrPlanes([]);
    setData([]);
    setDataBackup([]);
    setCharging(false);
  };

  const handleSelectZona = (valZ)=>{
    setZonaSelected(valZ);
    setCharging(true);
    const arrFil =  (dataZona.filter(value=> value.Zona.toString() === valZ.toString()))[0];
    setZonaSelectedObject(arrFil);
    setSelectedZona(true);
    if(arrFil.simpleQueue){
      setTypeService('simpleQueue')
      fetch('/api/mikrotik/clientesSimpleQueue',{
        method:'POST',
        body: JSON.stringify(arrFil),
        headers:{
            'Content-Type': 'application/json'
        }
      }) 
      .then(response=> response.json())
      .then(result =>{
          const arr = [];
          result.forEach(value => {
            const objeto = {};
            value.forEach((value2, index2)=>{
              let splitKey =  value2.field.toString().split('-');
              switch(splitKey.length){
                case 2: 
                    let key2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                    objeto[key2] = value2.value; 
                    break;
                case 3: 
                    let key3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                    objeto[key3] = value2.value;
                    break;
                case 4: 
                    let key4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                    objeto[key4] = value2.value;
                    break;
                default:
                    let splitKey2 =  value2.field.toString().split('.');
                    if(splitKey2.length === 2){
                      objeto.idSimpleQueue = value2.value;
                      objeto.idGeneral = value2.value;
                    }else{
                      if(value2.field === 'target'){
                        objeto.target = value2.value.split('/')[0];
                      }else  if(value2.field === 'name'){
                          objeto.idForMikrotik = value2.value;
                          objeto.name = value2.value;
                      }else{
                        objeto[value2.field] = value2.value;
                      }                     
                    }
                    break;
              }
            })
            arr.push(objeto);
          });
          fetch('/api/mikrotik/clientesAddressList',{
            method:'POST',
            body: JSON.stringify(arrFil),
            headers:{
                'Content-Type': 'application/json'
            }
          }) 
          .then(response2=> response2.json())
          .then(result2 =>{
            const arr2 = [];
            const arrMorosos = [];
            result2.forEach(value => {
              const objeto = {};
              value.forEach((value2, index2)=>{
                let splitKey =  value2.field.toString().split('-');
                switch(splitKey.length){
                  case 2: 
                      let key2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                      objeto[key2] = value2.value; 
                      break;
                  case 3: 
                      let key3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                      objeto[key3] = value2.value;
                      break;
                  case 4: 
                      let key4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                      objeto[key4] = value2.value;
                      break;
                  default:
                      let splitKey2 =  value2.field.toString().split('.');
                      if(splitKey2.length === 2){
                        objeto.idAddressList = value2.value 
                      }else{
                        objeto[value2.field] = value2.value;                      
                      }
                      break;
                }
              })
              arr2.push(objeto);
            });
            arr2.forEach(value=>{
              if(value.list === 'MOROSOS') arrMorosos.push(value.address)
            });
            const arrResult = [];
            arr.forEach(value=>{
              const objeto2 = {...value}
              if(arrMorosos.includes(value.target)){
                objeto2.status = 'Suspendido';
                const arrFil2 = (arr2.filter(value3=> value3.address === value.target))[0];
                objeto2.idAddressList = arrFil2.idAddressList;
                arrResult.push(objeto2);
              }else{
                objeto2.status = 'Activo';
                arrResult.push(objeto2);
              }
            });
            const arrResult2 = [];
            arrResult.forEach(value=>{
              const objeto = {...value};
              arrFil.Planes.forEach(value2=>{
                let maxLimitUp = value.maxLimit.split('/')[0];
                let maxLimitDown = value.maxLimit.split('/')[1];
                if(maxLimitUp === '3500000' || maxLimitDown === '13000000'){
                  objeto.plan = 'Plan 12 Megas(450)SQ';
                }else if(maxLimitUp === '3200000' || maxLimitDown === '16000000'){
                  objeto.plan = 'Plan de 16 Megas(450) SQ';
                }else if(maxLimitUp === '3000000' || maxLimitDown === '20000000'){
                  objeto.plan = 'Plan 20 megas(500)SQ';
                }else if(maxLimitUp === '1300000' || maxLimitDown === '6500000'){
                  objeto.plan = 'Plan 6 Megas(350)SQ';
                }else if(maxLimitUp === '3300000' || maxLimitDown === '20480000'){
                  objeto.plan = 'Plan de 20 Megas(850)SQ';
                }else if(maxLimitUp === '2000000' || maxLimitDown === '12000000'){
                  objeto.plan = 'Plan 12 Megas(350)SQ';
                }else if(maxLimitUp === '1000000' || maxLimitDown === '3000000'){
                  objeto.plan = 'Plan 3 Mega(250)SQ';
                }else{
                  objeto.plan = value.maxLimit;
                }
              })
              arrResult2.push(objeto);
            })
            setData(arrResult2);
            setDataBackup(arrResult2);
            setTimeout(()=>{setCharging(false)},1000);
          })  
      })
    }else if(arrFil.sysintercom){
      setTypeService('sysintercom');
      fetch('/api/mikrotik/clientesAddressList',{
        method:'POST',
        body: JSON.stringify(arrFil),
        headers:{
            'Content-Type': 'application/json'
        }
      }) 
      .then(response2=> response2.json())
      .then(result2 =>{
        const arr2 = [];
        result2.forEach(value => {
          const objeto = {};
          value.forEach((value2, index2)=>{
            let splitKey =  value2.field.toString().split('-');
            switch(splitKey.length){
              case 2: 
                  let key2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                  objeto[key2] = value2.value; 
                  break;
              case 3: 
                  let key3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                  objeto[key3] = value2.value;
                  break;
              case 4: 
                  let key4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                  objeto[key4] = value2.value;
                  break;
              default:
                  let splitKey2 =  value2.field.toString().split('.');
                  if(splitKey2.length === 2){
                    objeto.idTwo = value2.value;
                    objeto.idGeneral = value2.value;
                  }else if(value2.field === 'comment'){
                    objeto.idForMikrotik = value2.value;
                    objeto.comment = value2.value;
                    objeto.name = value2.value;
                  }else{
                    objeto[value2.field] = value2.value;                   
                  }
                  break;
            }
          })
          arr2.push(objeto);
        });
        const arrFilter_3 = arr2.filter(value=> value.idForMikrotik !== undefined);
        const arrFilter_2 = arrFilter_3.filter(value=> value.idForMikrotik !== ' ');
        const arrFilter_1 = arrFilter_2.filter(value=> value.idForMikrotik !== '');
        const arrFilter2 = arrFilter_1.filter(value=> 
          value !=='RED-CLIENTES' || 
          value !=='Redes_Raw' || 
          value !=='facebook' || 
          value !=='ips_autorizadas_wisphub' ||
          value !=='ips_permitidas_moroso' ||
          value !=='por_Nedetel' ||
          value !=='netflix' ||
          value !=='servers_wisphub' || 
          value !=='youtube' || 
          value !=='zoom_ips' ||
          value !=='zoom_voice2_ips' ||
          value !=='zoom_voice_ips' ||
          value !=='zoom_web' ||
          value !=='GOOGLE' ||
          value !=='LAN' 
        );
        const arrResult =  arrFilter2.map(value=>{
          const objeto2 = {...value};
          if(value.list === 'Moroso'){
            objeto2.status = 'Suspendido';
            objeto2.plan = value.list;
            objeto2.name = value.comment;
            objeto2.target = value.address;
            return objeto2
          }else{
            objeto2.status = 'Activo';
            objeto2.plan = value.list;
            objeto2.name = value.comment;
            objeto2.target = value.address;
            return objeto2
          }
        });
        const subArrPlanes = arrResult.map(value=> value.plan);
        const subArrPlanesFil = Array.from(new Set(subArrPlanes));
        const arrNoPlanes = [ 
          'Moroso',
          'RED-CLIENTES',
          'Redes_Raw',
          'facebook',
          'ips_autorizadas_wisphub',
          'ips_permitidas_moroso',
          'por_Nedetel',
          'netflix',
          'servers_wisphub',
          'youtube',
          'zoom_ips',
          'zoom_voice2_ips',
          'zoom_voice_ips',
          'zoom_web',
          'GOOGLE',
          'LAN' 
        ]
        const subArrPlanesFil2 = subArrPlanesFil.filter(el=> !arrNoPlanes.includes(el));
        fetch('/api/mikrotik/clientesSimpleQueue',{
          method:'POST',
          body: JSON.stringify(arrFil),
          headers:{
              'Content-Type': 'application/json'
          }
        }) 
        .then(response=> response.json())
        .then(async (result) =>{
            const arr = [];
            result.forEach(value => {
              const objeto = {};
              value.forEach((value2, index2)=>{
                let splitKey =  value2.field.toString().split('-');
                switch(splitKey.length){
                  case 2: 
                      let key2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                      objeto[key2] = value2.value; 
                      break;
                  case 3: 
                      let key3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                      objeto[key3] = value2.value;
                      break;
                  case 4: 
                      let key4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                      objeto[key4] = value2.value;
                      break;
                  default:
                      let splitKey2 =  value2.field.toString().split('.');
                      if(splitKey2.length === 2){
                        objeto.idSimpleQueue = value2.value;
                        objeto.idGeneral = value2.value;
                      }else{
                        if(value2.field === 'target'){
                          objeto.target = value2.value.split('/')[0];
                        }else  if(value2.field === 'name'){
                            objeto.idForMikrotik = value2.value;
                            objeto.name = value2.value;

                        }else{
                          objeto[value2.field] = value2.value;
                        }                     
                      }
                      break;
                }
              })
              arr.push(objeto);
            });
            const arrNew = await Promise.all(arr.map(el=>{ 
              const findEl = arrResult.find(el2=> el2.address === el.target);
              if(!findEl)
              return {
                ...el,
              }
              else
              return {
                ...findEl,
                idTwo:el.idGeneral
              }
            }));
            console.log(arrNew)
            setArrPlanes(subArrPlanesFil2);
            setData(arrNew);
            setDataBackup(arrNew);
            setTimeout(()=>{setCharging(false)},1000);
        })
        
      })
    }else if(arrFil.queueTree){
      setTypeService('queueTree');
      fetch('/api/mikrotik/clientesAddressList',{
        method:'POST',
        body: JSON.stringify(arrFil),
        headers:{
            'Content-Type': 'application/json'
        }
      }) 
      .then(response2=> response2.json())
      .then(result2 =>{
        const arr2 = [];
        result2.forEach(value => {
          const objeto = {};
          value.forEach((value2, index2)=>{
            let splitKey =  value2.field.toString().split('-');
            switch(splitKey.length){
              case 2: 
                  let key2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                  objeto[key2] = value2.value; 
                  break;
              case 3: 
                  let key3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                  objeto[key3] = value2.value;
                  break;
              case 4: 
                  let key4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                  objeto[key4] = value2.value;
                  break;
              default:
                  let splitKey2 =  value2.field.toString().split('.');
                  if(splitKey2.length === 2){
                    objeto.idAddressList = value2.value;
                    objeto.idGeneral = value2.value;
                  }else if(value2.field === 'comment'){
                    objeto.idForMikrotik = value2.value;
                    objeto.comment = value2.value;
                    objeto.name = value2.value;
                  }else{
                    objeto[value2.field] = value2.value;                   
                  }
                  break;
            }
          })
          arr2.push(objeto);
        });
        const arrFilter_3 = arr2.filter(value=> value.idForMikrotik !== undefined);
        const arrFilter_2 = arrFilter_3.filter(value=> value.idForMikrotik !== ' ');
        const arrFilter_1 = arrFilter_2.filter(value=> value.idForMikrotik !== '');
        const arrFilter2 = arrFilter_1.filter(value=> 
          value !=='RED-CLIENTES' || 
          value !=='Redes_Raw' || 
          value !=='facebook' || 
          value !=='ips_autorizadas_wisphub' ||
          value !=='ips_permitidas_moroso' ||
          value !=='por_Nedetel' ||
          value !=='netflix' ||
          value !=='servers_wisphub' || 
          value !=='youtube' || 
          value !=='zoom_ips' ||
          value !=='zoom_voice2_ips' ||
          value !=='zoom_voice_ips' ||
          value !=='zoom_web' ||
          value !=='GOOGLE' ||
          value !=='LAN' 
        );
        const arrResult =  arrFilter2.map(value=>{
          const objeto2 = {...value};
          if(value.list === 'Moroso'){
            objeto2.status = 'Suspendido';
            objeto2.plan = value.list;
            objeto2.name = value.comment;
            objeto2.target = value.address;
            return objeto2
          }else{
            objeto2.status = 'Activo';
            objeto2.plan = value.list;
            objeto2.name = value.comment;
            objeto2.target = value.address;
            return objeto2
          }
        });
        const subArrPlanes = arrResult.map(value=> value.plan);
        const subArrPlanesFil = Array.from(new Set(subArrPlanes));
        const subArrPlanesFil2 = subArrPlanesFil.filter(value=> 
          value !=='Moroso' || 
          value !=='RED-CLIENTES' || 
          value !=='Redes_Raw' || 
          value !=='facebook' || 
          value !=='ips_autorizadas_wisphub' ||
          value !=='ips_permitidas_moroso' ||
          value !=='por_Nedetel' ||
          value !=='netflix' ||
          value !=='servers_wisphub' || 
          value !=='youtube' || 
          value !=='zoom_ips' ||
          value !=='zoom_voice2_ips' ||
          value !=='zoom_voice_ips' ||
          value !=='zoom_web' ||
          value !=='GOOGLE' ||
          value !=='LAN' 
          );
        setArrPlanes(subArrPlanesFil2);
        setData(arrResult);
        setDataBackup(arrResult);
        setTimeout(()=>{setCharging(false)},1000);
      })
    }else{
      setTypeService('ppoeList');
      fetch('/api/mikrotik/clientesPpoeList',{
        method:'POST',
        body: JSON.stringify(arrFil),
        headers:{
            'Content-Type': 'application/json'
        }
      }) 
      .then(response=> response.json())
      .then(result =>{
        const arr = [];
        result.forEach(value => {
          const objeto = {};
          value.forEach((value2, index2)=>{
            let splitKey =  value2.field.toString().split('-');
            switch(splitKey.length){
              case 2: 
                  if(value2.field === 'remote-address') objeto.target = value2.value;
                  let key2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                  objeto[key2] = value2.value; 
                  break;
              case 3: 
                  let key3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                  objeto[key3] = value2.value;
                  break;
              case 4: 
                  let key4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                  objeto[key4] = value2.value;
                  break;
              default:
                  let splitKey2 =  value2.field.toString().split('.');
                  if(splitKey2.length === 2){
                    objeto.idGeneral = value2.value;
                  }else{
                    if(value2.field === 'name'){objeto.idRb = value2.value; objeto.idForMikrotik = value2.value}
                    if(value2.field === 'comment') objeto.name = value2.value;
                    if(value2.field === 'profile') objeto.plan = value2.value;
                    if(value2.field === 'disabled') objeto.status = value2.value === 'false' ? 'Activo' : 'Suspendido';
                    objeto[value2.field] = value2.value;                      
                  }
                  break;
            }
          })
          arr.push(objeto);
        });
        fetch('/api/mikrotik/clientesPpoeListActive',{
          method:'POST',
          body: JSON.stringify(arrFil),
          headers:{
              'Content-Type': 'application/json'
          }
        }) 
        .then(response2=> response2.json())
        .then(result2 =>{
          const arr2 = [];
          result2.forEach(value => {
            const objeto = {};
            value.forEach((value2, index2)=>{
              let splitKey =  value2.field.toString().split('-');
              switch(splitKey.length){
                case 2: 
                    let key2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                    objeto[key2] = value2.value; 
                    break;
                case 3: 
                    let key3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                    objeto[key3] = value2.value;
                    break;
                case 4: 
                    let key4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                    objeto[key4] = value2.value;
                    break;
                default:
                    let splitKey2 =  value2.field.toString().split('.');
                    if(splitKey2.length === 2){
                      objeto.idGeneralActive = value2.value;
                    }else{
                      objeto[value2.field] = value2.value;                      
                    }
                    break;
              }
            })
            arr2.push(objeto);
          });
          const arrActive = arr2.map(value=>value.address);
          const arrResult = arr.map(value=>{
            const objeto5 = {...value};
            if(arrActive.includes(value.target)){
              const ElFilter = (arr2.filter(value2=> value2.address === value.target))[0];
              objeto5.idGeneralActive = ElFilter.idGeneralActive;
              return(objeto5);
            }else{
              return objeto5;
            }
          });
          setData(arrResult);
          setDataBackup(arrResult);
          setTimeout(()=>{setCharging(false)},1000);
        });
        
      })
    }
  };

  const handleProcessing = useCallback((props)=>{
    const arrFil = data.map(value=>{
      if(value.idGeneral === props.idGeneral){
        return props
      }else{
        return value
      }
    });
    setData(arrFil);
  },[data]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSelectName = (value)=>{
    setUserName(value);
    const arr = data.filter(value2=> value2.idForMikrotik === value);
    setData(arr);
  };

  const handleClear = ()=>{
    setUserName('');
    setData(dataBackup);
  };

  return(
    <Grid container justifyContent='center' style={{padding:10}}>
      <Paper elevation={2} style={{width:'100%', height:'87vh'}}>
        <Grid container justifyContent='center'>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <Paper style={{height:60, padding:5}} >
            <Grid container spacing={1} style={{paddingTop:5}}>
              <Grid item xl={3} lg={3} md={3} sm={6} xs={6}>
                <Autocomplete
                  id="Zona"
                  options={dataZona.map(value=>value.Zona)}
                  value={zonaSelected || ''}                              
                  renderInput={(params) => <TextField {...params} label="Zona" variant="outlined" size='small' fullWidth color='primary'/>}
                  onChange={(e,value, reason)=>{
                      if(reason ===  'clear'){
                          handleClearZona()
                      }else{
                          handleSelectZona(value);
                      }
                  }}  
                />
              </Grid>
              <Grid item xl={3} lg={3} md={3} sm={6} xs={6} >
                <Autocomplete
                    id="Nombres"
                    options={data.map(value=>value.idForMikrotik)}
                    value={userName || ''}                              
                    renderInput={(params) => <TextField {...params} variant="outlined" size='small' fullWidth placeholder='Filtrado id' />}
                    onChange={(e,value, reason)=>{
                        if(reason ===  'clear'){
                            handleClear()
                        }else{
                            handleSelectName(value);
                        }
                    }}  
                />
            </Grid>
            </Grid>
          </Paper>
          </Grid>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <Grid container justifyContent='center' style={{height:'80vh'}}>
              { 
                isSelectedZona ?
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12} style={{ height:'9vh'}}>
                  {isCharging && <LinearProgress color='secondary' />}
                  <TableContainer className={classes.container}>
                        <Table stickyHeader aria-label="sticky table" size='small'>
                        <EnhancedTableHead
                            classes={classes}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            rowCount={data.length}
                            />
                        <TableBody>
                        {stableSort(data, getComparator(order, orderBy))
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row, index) => {
                            return (
                              <Roow 
                                key={`${row.id}-${index}`} 
                                rowInfo={row} 
                                handleProcessing={handleProcessing} 
                                typeService={typeService} 
                                zonaSelectedObject={zonaSelectedObject}
                                arrPlanes={arrPlanes}
                              />);
                            })}
                            
                        </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={data.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        labelRowsPerPage='Filas por Pagina'
                    />
                </Grid>
                :
                <Grid item style={{alignSelf:'center'}}>
                  <FacebookCircularProgress size={40}/>
                </Grid>
              } 
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid> 
    
  );
};

const Roow = memo(({ rowInfo, handleProcessing, typeService, zonaSelectedObject, arrPlanes })=>{

  return(
    <TableRow hover key={rowInfo.idGeneral}>
        <TableCell style={{fontSize: 12}}>
            {rowInfo.plan}
        </TableCell>
        <TableCell>
            {rowInfo.target}
        </TableCell>
        <TableCell>
            {rowInfo.idGeneral}
        </TableCell>
        <TableCell>
            {rowInfo.idTwo}
        </TableCell>
        <TableCell style={{fontSize: 12}}>
            {rowInfo.name }
        </TableCell>
        <TableCell style={{textAlign:'center'}}>   
            <Chip label={rowInfo.status} style={{background:rowInfo.idGeneralActive ? 'YellowGreen' : rowInfo.status === 'Suspendido' ? 'red' :  'DodgerBlue', color:'#fff',fontWeight:'bolder'}}/>
        </TableCell> 
        <TableCell>
          {
            typeService === 'sysintercom' ? <ActionSysIntercom rowInfo={rowInfo} handleProcessing={handleProcessing} typeService={typeService} zonaSelectedObject={zonaSelectedObject} arrPlanes={arrPlanes}/> :
            typeService === 'simpleQueue' ? <ActionSimpleQueue rowInfo={rowInfo} handleProcessing={handleProcessing} typeService={typeService} zonaSelectedObject={zonaSelectedObject} /> :
            typeService === 'queueTree' ? <ActionQueueTree rowInfo={rowInfo} handleProcessing={handleProcessing} typeService={typeService} zonaSelectedObject={zonaSelectedObject} arrPlanes={arrPlanes}/> :
            <ActionPpoeList rowInfo={rowInfo} handleProcessing={handleProcessing} typeService={typeService} zonaSelectedObject={zonaSelectedObject}/>
          }  
        </TableCell>  
    </TableRow>
  );
});

const ActionSysIntercom = memo(({ rowInfo, handleProcessing, zonaSelectedObject, arrPlanes  })=>{
  const [ openDialog, setOpenDialog ] = useState(false);
  const [ planSelect, setPlanSelect ] = useState('');
  const [ isSelectPlan, setSelectPlan ] = useState(false);
  
  const { enqueueSnackbar } = useSnackbar();

  useEffect(()=>{
    if(isSelectPlan){
      setSelectPlan(false);
      handleAction();
    }
  },[isSelectPlan]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleAction = ()=>{
    setOpenDialog(false);
    if(rowInfo.status === 'Activo'){
      fetch('/api/mikrotik/SuspenderClienteSysIntercom',{
        method:'POST',
        body: JSON.stringify({zonaSelectedObject, rowInfo}),
        headers:{
            'Content-Type': 'application/json'
        }
      }) 
      .then(response=> response.json())
      .then(result =>{
          enqueueSnackbar(result.message,{variant:'success'});         
          const objeto = {...rowInfo};
          objeto.status = 'Suspendido';   
          objeto.plan = 'Moroso';
          handleProcessing(objeto);      
      });
    }else{
      fetch('/api/mikrotik/ActivarClienteSysIntercom',{
        method:'POST',
        body: JSON.stringify({zonaSelectedObject, rowInfo, Plan:planSelect}),
        headers:{
            'Content-Type': 'application/json'
        }
      }) 
      .then(response=> response.json())
      .then(result =>{
        if(result.message){
          enqueueSnackbar(result.message,{variant:'success'});
          const objeto = {...rowInfo};
          objeto.status = 'Activo';
          objeto.plan = planSelect;
          handleProcessing(objeto);
        }else{
          enqueueSnackbar(result.status,{variant:'error'});
        }
            
      });
    }
  };

  const handleAlertClose = ()=>{
    setOpenDialog(false);
  };

  const handleAlert = ()=>{
    setOpenDialog(true);
  };

  const handleSelectPlan = (valP)=>{
    setPlanSelect(valP);
  };

  const handleClearPlan = ()=>{
    setPlanSelect('');
  };

  const handleContinuoActive = ()=>{
    if(rowInfo.status === 'Suspendido'){
      if(planSelect === ''){
        enqueueSnackbar('DEBE SELECCIONAR UN PLAN',{variant:'error'});
      }else{
        setSelectPlan(true);
      }
    }else{
      setSelectPlan(true);
    }
    
  };

  return(
    <Fragment>
      <Dialog
        open={openDialog}
        onClose={handleAlertClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{ rowInfo.status === 'Activo' ? 'Desea Suspender este Cliente?' : 'Desea Activar este Cliente?'}</DialogTitle>
        { rowInfo.status === 'Suspendido' &&
          <DialogContent>
            <Autocomplete
              id="Planes"
              freeSolo
              options={arrPlanes}
              value={planSelect || ''}                              
              renderInput={(params) => <TextField {...params} label="Plan" variant="outlined" size='small' fullWidth color='primary'/>}
              onChange={(e,value, reason)=>{
                  if(reason ===  'clear'){
                    handleClearPlan()
                  }else{
                    handleSelectPlan(value);
                  }
              }}  
            />
          </DialogContent>
        }
        <DialogActions style={{display:'flex', justifyContent:'center'}}>
        <Button onClick={handleContinuoActive} color="primary" variant='contained' style={{color:'#fff'}}> 
            Si
        </Button>
        <Button onClick={handleAlertClose} color="primary" autoFocus variant='contained' style={{color:'#fff'}}>
            No 
        </Button>
        </DialogActions>
      </Dialog>
      <Button 
        onClick={handleAlert} 
        size='small' 
        variant='contained' 
        color={rowInfo.status === 'Activo'? 'secondary' : 'primary'} 
        style={{color:'#fff', width:130}} 
        endIcon={rowInfo.status === 'Activo'? <BlockIcon style={{color:'#fff'}}/> : <CheckCircleOutlineIcon style={{color:'green'}}/>}>
        {rowInfo.status === 'Activo'? 'Suspender' : 'Activar'}
      </Button>
    </Fragment>
  );
});

const ActionSimpleQueue = memo(({ rowInfo, handleProcessing, zonaSelectedObject })=>{
  const [ openDialog, setOpenDialog ] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleAction = ()=>{
    setOpenDialog(false);
    if(rowInfo.status === 'Activo'){
      fetch('/api/mikrotik/SuspenderClienteSimpleQueue',{
        method:'POST',
        body: JSON.stringify({zonaSelectedObject, rowInfo}),
        headers:{
            'Content-Type': 'application/json'
        }
      }) 
      .then(response=> response.json())
      .then(result =>{
          enqueueSnackbar(result.message,{variant:'success'});         
          const objeto = {...rowInfo};
          objeto.status = 'Suspendido'; 
          objeto.idAddressList = result.idAddressList;         
          handleProcessing(objeto);           
      });
    }else{
      fetch('/api/mikrotik/ActivarClienteSimpleQueue',{
        method:'POST',
        body: JSON.stringify({zonaSelectedObject, rowInfo}),
        headers:{
            'Content-Type': 'application/json'
        }
      }) 
      .then(response=> response.json())
      .then(result =>{
          enqueueSnackbar(result.message,{variant:'success'});
          const objeto = {...rowInfo};
          objeto.status = 'Activo';
          handleProcessing(objeto);  
      });
    }
    
  };

  const handleAlertClose = ()=>{
    setOpenDialog(false);
  };

  const handleAlert = ()=>{
    setOpenDialog(true);
  };

  return(
    <Fragment>
      <Dialog
        open={openDialog}
        onClose={handleAlertClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{ rowInfo.status === 'Activo' ? 'Desea Suspender este Cliente?' : 'Desea Activar este Cliente?'}</DialogTitle>
        <DialogActions style={{display:'flex', justifyContent:'center'}}>
        <Button onClick={handleAction} color="primary" variant='contained' style={{color:'#fff'}}> 
            Si
        </Button>
        <Button onClick={handleAlertClose} color="primary" autoFocus variant='contained' style={{color:'#fff'}}>
            No 
        </Button>
        </DialogActions>
      </Dialog>
      <Button 
        onClick={handleAlert} 
        size='small' 
        variant='contained' 
        color={rowInfo.status === 'Activo'? 'secondary' : 'primary'} 
        style={{color:'#fff', width:130}} 
        endIcon={rowInfo.status === 'Activo'? <BlockIcon style={{color:'#fff'}}/> : <CheckCircleOutlineIcon style={{color:'green'}}/>}>
        {rowInfo.status === 'Activo'? 'Suspender' : 'Activar'}
      </Button>
    </Fragment>
  );
});

const ActionQueueTree = memo(({ rowInfo, handleProcessing, zonaSelectedObject, arrPlanes  })=>{
  const [ openDialog, setOpenDialog ] = useState(false);
  const [ planSelect, setPlanSelect ] = useState('');
  const [ isSelectPlan, setSelectPlan ] = useState(false);
  
  const { enqueueSnackbar } = useSnackbar();

  useEffect(()=>{
    if(isSelectPlan){
      setSelectPlan(false);
      handleAction();
    }
  },[isSelectPlan]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleAction = ()=>{
    setOpenDialog(false);
    if(rowInfo.status === 'Activo'){
      fetch('/api/mikrotik/SuspenderClienteQueueTree',{
        method:'POST',
        body: JSON.stringify({zonaSelectedObject, rowInfo}),
        headers:{
            'Content-Type': 'application/json'
        }
      }) 
      .then(response=> response.json())
      .then(result =>{
          enqueueSnackbar(result.message,{variant:'success'});         
          const objeto = {...rowInfo};
          objeto.status = 'Suspendido'; 
          objeto.plan = 'Moroso';      
          handleProcessing(objeto);  
      });
    }else{
      fetch('/api/mikrotik/ActivarClienteQueueTree',{
        method:'POST',
        body: JSON.stringify({zonaSelectedObject, rowInfo, Plan:planSelect}),
        headers:{
            'Content-Type': 'application/json'
        }
      }) 
      .then(response=> response.json())
      .then(result =>{
        if(result.message){
          enqueueSnackbar(result.message,{variant:'success'});
          const objeto = {...rowInfo};
          objeto.status = 'Activo';
          objeto.plan = planSelect;
          handleProcessing(objeto);
        }else{
          enqueueSnackbar(result.status,{variant:'error'});
        }
            
      });
    }
  };

  const handleAlertClose = ()=>{
    setOpenDialog(false);
  };

  const handleAlert = ()=>{
    setOpenDialog(true);
  };

  const handleSelectPlan = (valP)=>{
    setPlanSelect(valP);
  };

  const handleClearPlan = ()=>{
    setPlanSelect('');
  };

  const handleContinuoActive = ()=>{
    if(rowInfo.status === 'Suspendido'){
      if(planSelect === ''){
        enqueueSnackbar('DEBE SELECCIONAR UN PLAN',{variant:'error'});
      }else{
        setSelectPlan(true);
      }
    }else{
      setSelectPlan(true);
    }
    
  };

  return(
    <Fragment>
      <Dialog
        open={openDialog}
        onClose={handleAlertClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{ rowInfo.status === 'Activo' ? 'Desea Suspender este Cliente?' : 'Desea Activar este Cliente?'}</DialogTitle>
        { rowInfo.status === 'Suspendido' &&
          <DialogContent>
            <Autocomplete
              id="Planes"
              freeSolo
              options={arrPlanes}
              value={planSelect || ''}                              
              renderInput={(params) => <TextField {...params} label="Plan" variant="outlined" size='small' fullWidth color='primary'/>}
              onChange={(e,value, reason)=>{
                  if(reason ===  'clear'){
                    handleClearPlan()
                  }else{
                    handleSelectPlan(value);
                  }
              }}  
            />
          </DialogContent>
        }
        <DialogActions style={{display:'flex', justifyContent:'center'}}>
        <Button onClick={handleContinuoActive} color="primary" variant='contained' style={{color:'#fff'}}> 
            Si
        </Button>
        <Button onClick={handleAlertClose} color="primary" autoFocus variant='contained' style={{color:'#fff'}}>
            No 
        </Button>
        </DialogActions>
      </Dialog>
      <Button 
        onClick={handleAlert} 
        size='small' 
        variant='contained' 
        color={rowInfo.status === 'Activo'? 'secondary' : 'primary'} 
        style={{color:'#fff', width:130}} 
        endIcon={rowInfo.status === 'Activo'? <BlockIcon style={{color:'#fff'}}/> : <CheckCircleOutlineIcon style={{color:'green'}}/>}>
        {rowInfo.status === 'Activo'? 'Suspender' : 'Activar'}
      </Button>
    </Fragment>
  );
});

const ActionPpoeList = memo(({ rowInfo, handleProcessing, zonaSelectedObject })=>{

  const [ openDialog, setOpenDialog ] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleAction = ()=>{
    setOpenDialog(false);
    if(rowInfo.status === 'Activo'){
      fetch('/api/mikrotik/SuspenderClientePpoe',{
        method:'POST',
        body: JSON.stringify({zonaSelectedObject, rowInfo}),
        headers:{
            'Content-Type': 'application/json'
        }
      }) 
      .then(response=> response.json())
      .then(result =>{
          enqueueSnackbar(result.message,{variant:'success'});         
          const objeto = {...rowInfo};
          objeto.status = 'Suspendido'; 
          objeto.idAddressList = result.idAddressList;         
          handleProcessing(objeto);           
      });
    }else{
      fetch('/api/mikrotik/ActivarClientePpoe',{
        method:'POST',
        body: JSON.stringify({zonaSelectedObject, rowInfo}),
        headers:{
            'Content-Type': 'application/json'
        }
      }) 
      .then(response=> response.json())
      .then(result =>{
          enqueueSnackbar(result.message,{variant:'success'});
          const objeto = {...rowInfo};
          objeto.status = 'Activo';
          handleProcessing(objeto);  
      });
    }
  };

  const handleAlertClose = ()=>{
    setOpenDialog(false);
  };

  const handleAlert = ()=>{
    setOpenDialog(true);
  };

  return(
    <Fragment>
      <Dialog
        open={openDialog}
        onClose={handleAlertClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{ rowInfo.status === 'Activo' ? 'Desea Suspender este Cliente?' : 'Desea Activar este Cliente?'}</DialogTitle>
        <DialogActions style={{display:'flex', justifyContent:'center'}}>
        <Button onClick={handleAction} color="primary" variant='contained' style={{color:'#fff'}}> 
            Si
        </Button>
        <Button onClick={handleAlertClose} color="primary" autoFocus variant='contained' style={{color:'#fff'}}>
            No 
        </Button>
        </DialogActions>
      </Dialog>
      <Button 
        onClick={handleAlert} 
        size='small' 
        variant='contained' 
        color={rowInfo.status === 'Activo'? 'secondary' : 'primary'} 
        style={{color:'#fff', width:130}} 
        endIcon={rowInfo.status === 'Activo'? <BlockIcon style={{color:'#fff'}}/> : <CheckCircleOutlineIcon style={{color:'green'}}/>}>
        {rowInfo.status === 'Activo'? 'Suspender' : 'Activar'}
      </Button>
    </Fragment>
  );
});

const Mikrotik_List= ()=>{
  return (
      <SnackbarProvider maxSnack={3} hideIconVariant={false} dense anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}>
        <MikrotikList />
      </SnackbarProvider>
  );
};

export default Mikrotik_List;